import { render, staticRenderFns } from "./AgregarJurado.vue?vue&type=template&id=1847a076"
import script from "./AgregarJurado.vue?vue&type=script&lang=js"
export * from "./AgregarJurado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports